function isEmptyInputValue(value) {
    return value === null || value.length === 0;
}
const EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export class Validators {
    static min(min) {
        return (control) => {
            if (isEmptyInputValue(control) || isEmptyInputValue(min)) {
                return null;
            }
            const value = parseFloat(control);

            return !isNaN(value) && value < min ? { min: { min: min, actual: control } } : null;
        };
    }

    static max(max) {
        return (control) => {
            if (isEmptyInputValue(control) || isEmptyInputValue(max)) {
                return null;
            }
            const value = parseFloat(control);

            return !isNaN(value) && value > max ? { max: { max: max, actual: control } } : null;
        };
    }

    static required(control) {
        return isEmptyInputValue(control) ? { required: true } : null;
    }

    static requiredTrue(control) {
        return control === true ? null : { required: true };
    }

    static email(control) {
        if (isEmptyInputValue(control)) {
            return null;
        }
        return EMAIL_REGEXP.test(control) ? null : { email: true };
    }

    static minLength(minLength) {
        return (control) => {
            if (isEmptyInputValue(control)) {
                return null;
            }
            const length = control ? control.length : 0;

            return length < minLength ? { minlength: { requiredLength: minLength, actualLength: length } } : null;
        };
    }

    static maxLength(maxLength) {
        return (control) => {
            const length = control ? control.length : 0;

            return length > maxLength ? { maxlength: { requiredLength: maxLength, actualLength: length } } : null;
        };
    }

    static pattern(pattern) {
        if (!pattern) return Validators.nullValidator;
        let regex;
        let regexStr;

        if (typeof pattern === 'string') {
            regexStr = '';

            if (pattern.charAt(0) !== '^') regexStr += '^';

            regexStr += pattern;

            if (pattern.charAt(pattern.length - 1) !== '$') regexStr += '$';

            regex = new RegExp(regexStr);
        } else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return (control) => {
            if (isEmptyInputValue(control)) {
                return null;
            }
            const value = control;

            return regex.test(value) ? null : { pattern: { requiredPattern: regexStr, actualValue: value } };
        };
    }

    static nullValidator() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/validators/validate.js